import RolesMenu from './RolesMenu';

export default RolesMenu;
